module.exports = __webpack_public_path__ + "static/media/Lagertha 2.eac9b58e.jpg";